export default __webpack_public_path__ + "static/media/tl-sec.4c3fad3d.png";